import React from 'react';
import CommonBanner from "../component/Common/CommonBanner";
import { ImageConstants } from "../assets/img/ImageConstants";
import StaticSEOTags from '../component/DynamicSEO/StaticSEOTags';
import Img from "../assets/img/imagination/tourall.jpg";

const DomesticTourPackages = () => {
  return (
    <>
      <StaticSEOTags
        fallbackTitle="Domestic Tour Packages - Polifly Travels"
        fallbackDescription="Rediscover Pakistan with Polifly Travels' affordable and curated domestic tour packages. Stress-free travel for families, couples, groups, and more."
        fallbackKeywords="domestic tour packages, Pakistan tours, Murree, Swat, Hunza, Skardu, Gilgit, Fairy Meadows, Naran Kaghan, Neelum Valley, Kund Malir, Gwadar, Islamabad, Lahore, Karachi"
        fallbackOgTitle="Domestic Tour Packages - Polifly Travels"
        fallbackOgDescription="Explore Pakistan with curated domestic tour packages covering top destinations with comfort and ease."
        fallbackCanonicalUrl="https://poliflytravels.com/domestic-tour-packages/"
      />

      <CommonBanner
        heading="Domestic Tour Packages"
        img={ImageConstants.visabanner}
        pagination="Domestic Tour Packages"
      />

      <section className="domestic-tour-packages-area pt-5 pb-5 mt-5 mb-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="content-wrapper visa-content">
                <h2 className="mb-4">Polani Travels – Rediscover Pakistan Like Never Before</h2>
                <p className="mb-5">
                  Explore the hidden gems and iconic destinations of Pakistan with Polani Travels' affordable and carefully curated domestic tour packages. From majestic mountains to serene beaches, vibrant cities to historic landmarks — experience the very best of our beautiful homeland.
                </p>

                <div className="mb-5">
                  <h3 className="mb-3">Travel Within Pakistan, Effortlessly</h3>
                  <p>
                    Whether you're planning a weekend escape, honeymoon, family vacation, or group adventure, our domestic travel packages are designed to offer you a stress-free and memorable experience.
                  </p>
                </div>

              </div>
            </div>

            <div className="col-lg-6">
            <img src={Img} alt="img" />
            </div>

          </div>
          <div className='row mt-5 pb-5'>
            <div className='col-lg-6'>
            <div className="mb-5">
                  <h3 className="mb-3">Top Destinations We Cover</h3>
                  <ul className="benefits-list">
                    <li>Murree – Perfect for couples and family getaways</li>
                    <li>Swat, Kalam & Malam Jabba – Snowy peaks, lush valleys, and natural beauty</li>
                    <li>Hunza, Skardu & Gilgit – Stunning landscapes and cultural richness</li>
                    <li>Fairy Meadows & Naran Kaghan – For nature lovers and thrill seekers</li>
                    <li>Neelum Valley & Azad Kashmir – Tranquility, greenery, and breathtaking views</li>
                    <li>Gwadar & Kund Malir – Coastal charm and scenic drives</li>
                    <li>Islamabad, Lahore & Karachi – City life, history, and cultural tours</li>
                  </ul>
                </div> 
                </div>
            <div className='col-lg-6'>  
            <div className="mb-5">
                  <h3 className="mb-3">What's Included in Our Packages?</h3>
                  <p>Most of our domestic tour plans feature:</p>
                  <ul className="benefits-list">
                    <li>Comfortable transportation</li>
                    <li>Hotel accommodations</li>
                    <li>Breakfast and dinner (in most packages)</li>
                    <li>Sightseeing and local guide support</li>
                    <li>Pickup and drop-off service options</li>
                  </ul>
                </div>
              
            </div>
          </div>

          <div className='row'>
            <div className='col-lg-6'>
        
                <div className="mb-5">
                  <h3 className="mb-3">Why Travel with Polani Travels?</h3>
                  <ul className="benefits-list">
                    <li>Trusted and experienced travel planning team</li>
                    <li>Both budget-friendly and premium packages available</li>
                    <li>Custom itineraries based on your preferences</li>
                    <li>Dedicated support throughout your journey</li>
                  </ul>
                </div> </div>
            <div className='col-lg-6'>  
          
                <div className="get-in-touch mb-5">
                  <h3 className="mb-3">Ready for Your Next Trip?</h3>
                  <p>
                    Tell us your dream destination, and Polani Travels will take care of everything — from bookings to transport and beyond. Rediscover Pakistan with ease, comfort, and complete peace of mind.
                  </p>
                  <p className="mt-3"><strong>Polani Travels – Explore Pakistan with Passion.</strong></p>
               
                </div>
            </div>
          </div>
         
        </div>
      </section>
    </>
  );
};

export default DomesticTourPackages;